/*
 * Project Configs Here
 */

export const PRODUCTION = process.env.REACT_APP_PRODUCTION;
const LOCAL_URL = process.env.REACT_APP_LOCAL_URL;
const PRODUCTION_URL = process.env.REACT_APP_PRODUCTION_URL;

export const CONFIG = {
  SITE_NAME: process.env.REACT_APP_WEBSITE_NAME,
  VERSION: "v" + process.env.REACT_APP_VERSION,
  // DON'T CHANGE USER ROLES VALUES
  USER_ROLES: {
    Admin: 1,
    Customer: 2,
    Supplier: 3,
    Consignor: 4,
    Consignee: 5,
    Transporter: 6,
    Distributor: 7,
    Retailer: 8,
    Driver: 9,
    SalesTeam: 14,
    MarketingTeam: 15,
    Accounts: 16,
    Warehouse: 17,
    Tracking: 18,
    Support: 19,
    Placement: 20,
  },
  MAX_FILE_SIZE: 5,
};

export const API_CONFIG = {
  API_URL: PRODUCTION === "true" ? PRODUCTION_URL : LOCAL_URL,
  STATIC_URL:
    PRODUCTION === "true" ? PRODUCTION_URL : "http://192.168.179.238:8001/",
  METHODS: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  },
  TIMEOUT: 35 * 1000,
};

export const FORMATS = {
  SQL_DATE: "YYYY-MM-DD HH:mm:ss",
  SQL_DATE_ONLY: "YYYY-MM-DD",
  DATE: "DD-MM-YYYY HH:mm:ss",
  DATE_ONLY: "DD-MM-YYYY",
  DATE_PICKER_FORMAT: "dd-MM-yyyy",
  REPORT_TITLE_DATE: "MMM DD, YYYY",
  REPORT_DATE_WITH_TIME: "MMM DD, YYYY HH:mm:ss",
  MONTH_ONLY: "MMMM",
  MONTH_AND_YEAR_ONLY: "MMMM - YYYY",
  GRAPH_TIME: "HH:mm",
};

export const RESOURCE_SLOTS = {
  SLOT_1: "08:00",
  SLOT_2: "09:00",
  SLOT_3: "10:00",
  SLOT_4: "11:00",
  SLOT_5: "12:00",
  SLOT_6: "13:00",
  SLOT_7: "14:00",
  SLOT_8: "15:00",
  SLOT_9: "16:00",
  SLOT_10: "17:00",
  SLOT_11: "18:00",
  SLOT_12: "19:00",
  SLOT_13: "20:00",
};

export const DEFAULTS = {
  BTN_TYPE: "outlined",
  DIALOG_SIZE: "sm",
  MAP_TYPE: 1,
  PAGE_LENGTH: 10000,
};

export const LOCAL_STORAGE = {
  USER_INFO: "nUserInfo",
  ACCESS_TOKEN: "nToken",
  REMEMBER_ME: "nRemember",
};

export const NOTIFY = {
  WARNING: "warning",
  SUCCESS: "success",
  ERROR: "error",
  AUTO_HIDE_DURATION: 3000,
};

export const BTN_VARIENTS = {
  TEXT: "text",
  OUTLINED: "outlined",
  CONTAINED: "contained",
};

export const UNITS = {
  PRICE: " €",
};

export const LEAVE_STATUS = {
  APPROVE: "Approve",
  APPLIED: "Applied",
  REJECT: "Reject",
};

export const GRAPH_TYPES = {
  STACKED_BAR: "stakedbar",
  BAR: "bar",
  COLUMN: "column",
  PIE: "pie",
  SOLIDGAUGE: "solidgauge",
};

export const CRM_LEAD_STATUS = {
  NEW_LEAD: "New Lead",
  VERIFIED: "Verified",
  ASSIGNED: "Assigned",
  STORE_VISIT: "Store Visit",
  DOCUMENT_VERIFICATION: "Document Verification",
  APPROVALS: "Approvals",
  QUALIFIED: "Qualified",
  CONVERTED: "Converted",
  CUSTOMER: "Customer",
};

export const DOC_UPLOAD_STATUS = {
  UPLOADED: "Uploaded",
  VERIFIED: "Verified",
  REJECTED: "Rejected",
};
